export const getFields = message => {
  let $ = window.$;
  let doc = document.createElement("div");
  console.log(message);
  doc.innerHTML = message;
  let fields = [];
  $(doc)
    .find("label")
    .each((i, item) => {
      let id = $(item).attr("data-id");
      if (fields.indexOf(id) == -1) fields.push(id);
    });
  return fields;
};
